import EmptyInsights from '@static/images/empty-state/no-insights.svg';
import { useTranslation } from 'react-i18next';

import styles from './ScheduleDemoBanner.module.scss';

export const ScheduleDemoBanner = () => {
  const { t } = useTranslation(['stream']);

  return (
    <div className={styles.scheduleDemoBannerRoot}>
      <div className={styles.content}>
        <h3 className={styles.title}>{t('stream:scheduleDemo.title')}</h3>
        <p className={styles.description}>
          {t('stream:scheduleDemo.description')}
        </p>
        <a
          className={styles.styledLink}
          href="https://calendar.app.google/pRJ9ZMyBF3tykQD57"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('stream:scheduleDemo.button')}
        </a>
      </div>
      <EmptyInsights />
    </div>
  );
};
